import React from 'react'
import { Link } from 'react-router-dom'
import ImageLoader from 'alt-imageloader'

const ReferencesList = (props) => {
    if (props.itemsData.length < 1) {
        return (
            <div className="refereces-list">
                <div className="col-md-6 col-sm-6">
                    <div className="reference-item reference-item--left reference-item--loading">
                    </div>
                </div>
                <div className="col-md-6 col-sm-6">
                    <div className="reference-item reference-item--right reference-item--loading">
                    </div>
                </div>
            </div>
        )
    }

    let whiteStyleClass = ''
    if (props.isBckDark) {
        whiteStyleClass = 'white-text'
    }

    const listItems = props.itemsData.map((val, key) => {
        const sideClass = key % 2 === 0 ? 'reference-item--left' : 'reference-item--right'

        return (
            <div className="col-md-6 col-sm-6" key={key}>
                <Link
                    to={`${props.path}/${val.id}`}
                    onClick={props.setModalData.bind(null, val)}
                >
                    <div
                        className={`reference-item ${sideClass}`}
                    >
                        <ImageLoader
                            background={`/uploaded/${val.glavna_slika}`}
                            animationDelay={200}
                            className="alt-imageloader--gray"
                        />
                        <div className="reference-inner hidden-sm hidden-xs">
                            <div className="reference-item-sqf">
                                <img
                                    className="reference-item-sqf__img"
                                    src="/images/ico/bed_house.png"
                                />
                                <span className="reference-item-sqf__text">
                                    {val.povrsina || '-'}
                                </span>
                            </div>
                            <div className="reference-item-info">
                                <p className="reference-item-info__year">
                                    {val.godina}
                                </p>
                                <h2 className="reference-item-info__title">
                                    {val.naziv}
                                </h2>
                                <h3 className="reference-item-info__location">
                                    {val.lokacija}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="reference-responsive-info visible-sm visible-xs">
                        <div className="reference-item-info--resp">
                            <p className="reference-item-info__year">
                                {val.godina}
                            </p>
                            <h2 className={`reference-item-info__title ${whiteStyleClass}`}>
                                {val.naziv}
                            </h2>
                            <h3 className={`reference-item-info__location ${whiteStyleClass}`}>
                                {val.lokacija}
                            </h3>
                        </div>
                    </div>
                </Link>
            </div>
        )
    })

    return (
        <div className="refereces-list">
            {listItems}
        </div>
    )
}

ReferencesList.defaultProps = {
    itemsData: [],
    setModalData: () => {},
    path: '',
    isBckDark: false
}

export default ReferencesList



// WEBPACK FOOTER //
// ./src/scripts/components/ReferencesList.jsx